import React, { useState, useContext, useEffect } from "react";
import PropTypes from 'prop-types';
import { Container, Grid, Box, TextField, FormControlLabel, Checkbox, Button, FormControl, IconButton, Snackbar, Alert, FormLabel, CircularProgress } from '@mui/material';
import { Link, useNavigate } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { account } from '../../shared/Utils'
import { RootStoreContext } from "../../app/store/root";
import { observer } from "mobx-react-lite";
import { Catalogos } from "../../app/util/catalogos";
import Alerts from "../../shared/Alerts";
import LogisticBackdropStore from "../../shared/LogisticBackdrop";
import DialogComponent from "../../app/common/DialogComponent";
import { EnumPerfiles } from "../../shared/Enumerables";
function DialogForgotPasss(props) {

    const { onClose, open } = props;

    const rootStore = useContext(RootStoreContext);

    const [correo, setMail] = useState(null)
    const [errorCorreo, setErrorCorreo] = React.useState(false);
    const [errorCorreoMsj, setErrorCorreoMsj] = React.useState("");
    const [cargaInicial, setCargaInicial] = React.useState(true);

    const [showConfirmCancel, setShowConfirmCancel] = useState(false)

    const cancelarClick = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        event.preventDefault();
        setShowConfirmCancel(true)
    };

    const onChangeMail = (e) => {
        setMail(e.target.value);
        setCargaInicial(false)
    }

    const emailValidation = () => {
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!correo || regex.test(correo) === false) {
            setErrorCorreo(true)
            setErrorCorreoMsj("El formato del correo electrónico debe ser nombre@ejemplo.com")
            return false;
        }
        setErrorCorreo(false)
        setErrorCorreoMsj('')
        return true;
    }

    const generarCodigoRecuperarContrasenia = (e) => {
        if (emailValidation()) {
            rootStore.logisticBackdropStore.openLoading()
            fetch(`${process.env.REACT_APP_API_LOGISTICA}/api/Auth/GenerarCodigoRecuperarContrasenia/${correo}`,
                {
                    method: 'GET',
                    mode: 'cors',
                    cache: 'no-cache',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then((response) => response.json()).then((response) => {
                    if (response.data.success) {
                        onClose(false)
                        setTimeout(() => rootStore.logisticBackdropStore.closeLoading(), 500)
                        rootStore.alertStore.alertSuccess(`Te enviamos un correo electrónico con instrucciones para restablecer tu contraseña a ${correo}. Si no lo ves en tu bandeja de entrada revisa la carpeta de correo no deseado.`)
                    }
                    else {
                        rootStore.alertStore.alertError(response.data.mensaje)
                        setTimeout(() => rootStore.logisticBackdropStore.closeLoading(), 500)
                    }
                }).catch((error) => {
                    rootStore.alertStore.alertError('Error al consumir servicio')
                    setTimeout(() => rootStore.logisticBackdropStore.closeLoading(), 500)
                });
        }
    }


    return (
        <Dialog onClose={cancelarClick} open={open} maxWidth={'sm'} fullWidth={true} disableEscapeKeyDown>
            <DialogTitle>
                Recuperación de contraseña
                <IconButton aria-label="close"
                    onClick={cancelarClick}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <p>Ingresa tu correo electrónico y te enviaremos un email con instrucciones sobre cómo reestablecer tu contraseña.</p>
                <Box
                    noValidate
                    component="form"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        m: 'auto',
                        width: '100',
                    }}
                >
                    <FormControl sx={{ mt: 1, minWidth: 120 }}>
                        <TextField
                            size="small"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Correo electrónico"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            onChange={e => onChangeMail(e)}
                            onBlur={e => emailValidation()}
                            error={errorCorreo}
                            helperText={errorCorreoMsj}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    event.preventDefault()
                                    generarCodigoRecuperarContrasenia(event)
                                }
                            }}
                        />
                    </FormControl>
                </Box>
            </DialogContent>

            <DialogActions variant="paddi">
                <Button onClick={cancelarClick} variant="contained" color="secondary" sx={{ color: '#fff' }}>Cerrar</Button>
                <Button onClick={e => generarCodigoRecuperarContrasenia(e)} variant="contained" disabled={(errorCorreo || cargaInicial)}>Enviar correo</Button>
            </DialogActions>
            <DialogComponent
                Open={showConfirmCancel}
                Message="Si cierra o cancela esta ventana se perderá la información capturada. ¿Está seguro que desea continuar?"
                OnClose={() => setShowConfirmCancel(false)}
                OnAccept={() => {
                    onClose(false);
                    setShowConfirmCancel(false);
                }}
            />
        </Dialog>
    );
}

DialogForgotPasss.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

const LoginComponent = ({ tipoLogin }) => {

    const rootStore = useContext(RootStoreContext);
    const {
        sesionCerradaPorInactividad,
        setCerrarSesionPorInactividad,
        iniciarSesion,
        enviaCodigoAutenticacion: _enviaCodigoAutenticacion
    } = rootStore.authStore

    const {
        getInformacionUsuario: _getInformacionUsuario,
    } = rootStore.usuarioStore

    const EnumTipoValidacion = {
        correoNoExiste: 1,
        errorEnPassword: 2,
        errorEnPasswordNoIntentos: 3,
        usuarioInactivo: 4,
        sesionBloqueada: 5
    }

    const navigate = useNavigate();
    const [recordarUsuario, setRecodarUsuario] = React.useState(false)    

    const [open, setOpen] = React.useState(false);
    const [loginModel, setModelLogin] = useState({ correo: null, password: null })

    const [mostrarMensaje, setMostrarMensaje] = React.useState(false)
    const [mensaje, setMensaje] = React.useState('')

    const [errorCorreo, setErrorCorreo] = React.useState(false);
    const [errorCorreoMsj, setErrorCorreoMsj] = React.useState("");

    const [errorPsw, setErrorPsw] = React.useState(false);
    const [errorPswMsj, setErrorPswMsj] = React.useState("");

    const [cargaInicial, setCargaInicial] = React.useState(true);

    const handleClickOpen = () => { setOpen(true); }

    const onChangeRecordarUsuario = (e) => {
        setRecodarUsuario(!recordarUsuario)
    }

    const handleClose = (value) => {
        setOpen(value);
    }

    const setMail = (e) => {
        setModelLogin({ correo: e.target.value, password: loginModel.password });
        setCargaInicial(false)
    }

    const setPassword = (e) => {
        setModelLogin({ correo: loginModel.correo, password: e.target.value })
        setCargaInicial(false)
    }

    const emailValidation = () => {
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!loginModel.correo || regex.test(loginModel.correo) === false) {
            setErrorCorreo(true)
            setErrorCorreoMsj("El formato del correo electrónico debe ser nombre@ejemplo.com")
            return false;
        }
        setErrorCorreo(false)
        setErrorCorreoMsj('')
        return true;
    }

    const passwordValidation = () => {
        if (loginModel.password?.length >= 6 && loginModel.password?.length <= 12) {
            setErrorPsw(false)
            setErrorPswMsj('')
            return true
        }
        setErrorPsw(true)
        setErrorPswMsj('La contraseña debe tener entre 6 y 12 caracteres.')
        return false
    }

    const onSubmitClick = async (e) => {
        setMostrarMensaje(false)
        if (emailValidation()) {
            setCerrarSesionPorInactividad(false)
            rootStore.logisticBackdropStore.openLoading()
            let response = await iniciarSesion(loginModel)
            if (response.data.success) {
                account.saveToken(response.data.token)
                administrarCookie()
                if (response.data.autenticacion2Pasos) {
                    enviaCodigoAutenticacion()
                }
                else {
                    rootStore.alertStore.alertSuccess('Información de inicio de sesión validado correctamente. Redirigiendo a la pantalla de inicio.');
                    //save account in storage
                    let accountData = await _getInformacionUsuario()
                    account.saveDatosUsuario(accountData)
                    rootStore.logisticBackdropStore.closeLoading()
                    if (accountData?.perfil.toUpperCase() === EnumPerfiles.Proveedor)
                        navigate('/Proveedores/Dashboard')
                    else if (accountData?.perfil.toUpperCase() === EnumPerfiles.Administrador || accountData?.perfil.toUpperCase() === EnumPerfiles.Empleado)
                        navigate('/Usuarios/Dashboard')
                    else
                        navigate('/Usuarios/Home')
                }
            }
            else {
                rootStore.logisticBackdropStore.closeLoading()
                if (response.data.idTipoValidacion == EnumTipoValidacion.errorEnPasswordNoIntentos) {
                    //mostrar modal de numero de intentos
                    rootStore.alertStore.alertError(response.data.mensaje);
                }
                else if (response.data.idTipoValidacion == EnumTipoValidacion.sesionBloqueada) {
                    //mostrar mensaje de sesion bloqueada
                    setMostrarMensaje(true)
                    setMensaje(response.data.mensaje)
                }
                else {
                    rootStore.alertStore.alertError(response.data.mensaje);
                }
            }
        }
    }

    const enviaCodigoAutenticacion = async () => {
        let response = await _enviaCodigoAutenticacion()
        if (response.data) {
            rootStore.logisticBackdropStore.closeLoading()
            rootStore.alertStore.alertSuccess('Código enviado al correo con éxito.');
            setTimeout(() => { navigate('/Auth') }, 1500);
        } else {
            rootStore.logisticBackdropStore.closeLoading()
            rootStore.alertStore.alertError('Error al enviar el código al correo.');
        }
    }

    const administrarCookie = () => {
        if (recordarUsuario) {            
            window.localStorage.setItem("correo", account.encryptString(loginModel.correo))
            window.localStorage.setItem('password', account.encryptString(loginModel.password))
            //setCookie('correo', account.encryptString(loginModel.correo), { path: '/' });
            //setCookie('password', account.encryptString(loginModel.password), { path: '/' });
        } else {
            window.localStorage.removeItem("correo")
            window.localStorage.removeItem("password")
            //removeCookie('correo')
            //removeCookie('password')
        }
    }

    useEffect(() => {
        leerCookies();
    }, [])

    const leerCookies = () => {
        /*if (cookies.correo) {
            setRecodarUsuario(true)
            setModelLogin({ correo: account.decryptString(cookies.correo), password: account.decryptString(cookies.password) })
            setCargaInicial(false)
        }*/
        let correo = window.localStorage.getItem("correo")
        let password = window.localStorage.getItem("password")
        if(correo && password){
            setRecodarUsuario(true)
            setModelLogin({ correo: account.decryptString(correo), password: account.decryptString(password) })
            setCargaInicial(false)
        }
    }

    return (
        <React.Fragment>
            <Container component="main" maxWidth="xs">
                <LogisticBackdropStore />
                <Alerts />
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                    <Box component="form" noValidate sx={{ mt: 1 }}>
                        {mostrarMensaje &&
                            <div>
                                <FormLabel>INICIO DE SESIÓN BLOQUEADO</FormLabel>
                                <FormLabel>{mensaje}</FormLabel>
                            </div>
                        }
                        {sesionCerradaPorInactividad &&
                            <div>
                                <FormLabel>SESIÓN CERRADA</FormLabel>
                                <FormLabel>Se ha cerrado su cuenta por motivos de seguridad</FormLabel>
                            </div>
                        }
                        <TextField
                            InputLabelProps={{ shrink: loginModel.correo ? true : false }}
                            size="small"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Correo electrónico"
                            name="email"
                            autoFocus
                            onChange={e => {
                                setMail(e)
                            }}
                            onBlur={e => emailValidation()}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    event.preventDefault()
                                    onSubmitClick(event)
                                }
                            }}
                            error={errorCorreo}
                            helperText={errorCorreoMsj}
                            value={loginModel.correo}
                        />
                        <TextField
                            InputLabelProps={{ shrink: loginModel.password ? true : false }}
                            size="small"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Contraseña"
                            type="password"
                            id="password"
                            onChange={e => {
                                setPassword(e)
                                setErrorPsw((e.target.value.length < 6 || e.target.value.length > 12) ? true : false)
                                setErrorPswMsj((e.target.value.length < 6 || e.target.value.length > 12) ? 'La contraseña debe tener entre 6 y 12 caracteres.' : '')
                            }}
                            onBlur={e => passwordValidation()}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    event.preventDefault()
                                    onSubmitClick(event)
                                }
                            }}
                            error={errorPsw}
                            helperText={errorPswMsj}
                            value={loginModel.password}
                        />
                        <Grid container sx={{ alignItems: 'center' }}>
                            <Grid item xs>
                                <button type="button" className="btn btn-link" onClick={handleClickOpen}>
                                    Olvidé mi contraseña
                                </button>
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    control={<Checkbox value="remember" color="primary" checked={recordarUsuario} onChange={e => onChangeRecordarUsuario(e)} />}
                                    label="Recuérdame"
                                />
                            </Grid>
                        </Grid>
                        <Button
                            fullWidth
                            variant="contained"
                            sx={{ mt: 2, mb: 2 }}
                            disabled={(errorPsw || errorCorreo || cargaInicial)}
                            onClick={e => onSubmitClick(e)}
                        >
                            Acceder
                        </Button>
                        {/* {tipoLogin === 0 &&
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 2, mb: 2 }}
                                disabled={(errorPsw || errorCorreo || cargaInicial)}
                                onClick={e => onSubmitClick(e)}
                            >
                                Acceder
                            </Button>
                        }
                        {tipoLogin === 1 &&
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 2, mb: 2 }}
                                disabled={(errorPsw || errorCorreo || cargaInicial)}
                                onClick={e => onSubmitClick(e)}
                            >
                                Acceder
                            </Button>
                        } */}
                        <Grid container direction={'column'} justifyContent="center" alignItems="center">
                            <Grid item>
                                ¿Eres proveedor?
                            </Grid>
                            <Grid item>
                                <Link to={"/Registrarse"} >
                                    <button type="button" className="btn btn-link">
                                        Registrarse
                                    </button>
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <DialogForgotPasss open={open} onClose={handleClose} />
            </Container>
        </React.Fragment>
    );
}

export default observer(LoginComponent);